<ion-header class="ion-no-border">
  <ion-toolbar color="translucent">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" fullscreen></ion-content>
